// extracted by mini-css-extract-plugin
module.exports = {"logo-margin":"-Nd_W"};